import type { Page_Flexcontent_Flex_Content } from '~/graphql/types'
import clsx from 'clsx'
import { Fragment } from 'react'
import Animated from '~/components/elements/Animated'
import { losseContentParse, LosseLink } from '@ubo/losse-sjedel'

export default function ContentExternalLinks({ fields }: { fields: Page_Flexcontent_Flex_Content }) {
  return (
    <section data-component="ContentExternalLinks" className="section">
      <div className="container">
        <Animated delay={100}>
          <h2 className={clsx('title--semi-large pb-4')}>
            {fields.title.split('|').map((t, i) => (
              <Fragment key={i}>
                <span>{t}</span>
                <br />
              </Fragment>
            ))}
          </h2>
        </Animated>
        <Animated delay={150}>
          <h3 className={clsx('title--light text-site-base')}>{fields.subtitle}</h3>
        </Animated>
        <div className="lg:px-8 flex lg:flex-row flex-col lg:justify-between lg:items-center gap-y-7 gap-x-20 mt-12 lg:mt-16">
          {fields.items.map((item, index) => (
            <Animated delay={300} key={index}>
              <div
                style={{
                  animationDelay: `${index * 100 + 300}ms`
                }}
                className="flex items-center gap-7"
                key={index}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                  <path d="M36.0289 0H23.3774V18.9771H36.0289V0Z" fill="#78BF00" />
                  <path d="M36.0289 40.4296H23.3774V59.4067H36.0289V40.4296Z" fill="#78BF00" />
                  <path d="M59.4063 23.3777H40.4292V36.0291H59.4063V23.3777Z" fill="#78BF00" />
                  <path d="M18.9771 23.3777H0V36.0291H18.9771V23.3777Z" fill="#78BF00" />
                </svg>
                <div>
                  <div className="text-xl sm:text-2xl font-bold mb-1 sm:mb-2">{item.title}</div>
                  <LosseLink className="text-site-conversion hover:underline" target={item.link.target || '_blank'} to={item.link.url}>
                    {losseContentParse(item.link.title)}
                  </LosseLink>
                </div>
              </div>
            </Animated>
          ))}
        </div>
      </div>
    </section>
  )
}
